import React from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";

function CollageRegistration_step_4({ register, errors }) {
  return (
    <>
      <h5 className="step-heading">
        D. School Representative (Authorized Signatory)
      </h5>

      <div className="form_holder">
        <div className="row">
          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Representative First Name</Form.Label>
              <Form.Control
                type="text"
                {...register("r_first_name", {
                  required: "Representative First Name is required",
                })}
                placeholder="Representative First Name"
              />
              {errors.r_first_name && (
                <Form.Text className="text-danger">
                  {errors.r_first_name.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Representative Last Name</Form.Label>
              <Form.Control
                type="text"
                {...register("r_last_name", {
                  required: "Representative Last Name is required",
                })}
                placeholder="Representative Last Name"
              />
              {errors.r_last_name && (
                <Form.Text className="text-danger">
                  {errors.r_last_name.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Representative Position</Form.Label>
              <Form.Control
                type="text"
                {...register("r_position", {
                  required: "Representative Position is required",
                })}
                placeholder="Representative Position"
              />
              {errors.r_position && (
                <Form.Text className="text-danger">
                  {errors.r_position.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Representative Email</Form.Label>
              <Form.Control
                type="text"
                {...register("r_email", {
                  required: "Representative Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
                placeholder="Representative Email"
              />
              {errors.r_email && (
                <Form.Text className="text-danger">
                  {errors.r_email.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Representative Office Contact no</Form.Label>
              <Form.Control
                type="text"
                {...register("r_contact", {
                  required: "Representative Office Contact no is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Please enter a valid 10-digit phone number",
                  },
                })}
                placeholder="Representative Office Contact no"
              />
              {errors.r_contact && (
                <Form.Text className="text-danger">
                  {errors.r_contact.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-6">
            <Form.Group className="mb-3">
              <Form.Label>Authorization to Sign Internship</Form.Label>
              <div className="d-flex gap-3">
                <Form.Check
                  type="radio"
                  label="Yes"
                  value="1"
                  {...register("auth_to_sign_internship", {
                    required: "Please select an option",
                  })}
                />

                {/* NO */}
                <Form.Check
                  type="radio"
                  label="No"
                  value="0"
                  {...register("auth_to_sign_internship", {
                    required: "Please select an option",
                  })}
                />
              </div>

              {errors?.auth_to_sign_internship && (
                <Form.Text className="text-danger">
                  {errors.auth_to_sign_internship.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>
      </div>
    </>
  );
}

export default CollageRegistration_step_4;
